import { render, staticRenderFns } from "./JobGroup.vue?vue&type=template&id=4716e4ff&"
import script from "./JobGroup.vue?vue&type=script&lang=js&"
export * from "./JobGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports